import { Component, OnInit, Input } from '@angular/core';
import { IFeaturedContentModel } from '@models';

@Component({
  selector: 'app-featured-card',
  templateUrl: './featured-card.component.html',
  styleUrls: ['./featured-card.component.scss']
})
export class FeaturedCardComponent implements OnInit {
  @Input() content: IFeaturedContentModel;

  constructor() { }

  ngOnInit(): void {
  }

}
